import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { testimonials } from '../mock';
import VideoTestimonials from './VideoTestimonials';

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];

  const prev = () => setIdx((idx - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((idx + 1) % testimonials.length);

  return (
    <section id="reviews" className="py-16 lg:py-24 bg-[#7BB7DC]/25">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-[#E64B2B] uppercase tracking-[0.25em] font-black text-xs">Parent reviews</span>
          <h2 className="mt-3 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">
            Loved by <span className="text-[#4FB3B8]">2,252+ families</span> across India.
          </h2>
        </div>

        <VideoTestimonials />

        <div className="relative bg-[#FFF8EC] rounded-3xl border-2 border-[#2C3E50] p-8 lg:p-12 paper-shadow">
          <Quote className="absolute -top-5 -left-2 text-[#E64B2B] bg-[#FFF8EC] rounded-full p-1 border-2 border-[#2C3E50]" size={44} />
          <div className="flex gap-1 mb-4">
            {Array.from({ length: t.rating }, (_, i) => (
              <Star key={`star-${i}`} size={20} fill="#F4B93E" strokeWidth={0} />
            ))}
          </div>
          <blockquote className="text-xl lg:text-2xl text-[#2C3E50] font-semibold leading-relaxed" style={{ fontFamily: 'Fraunces, serif' }}>
            “{t.text}”
          </blockquote>
          <div className="mt-6 flex items-center justify-between">
            <div>
              <div className="font-black text-[#2C3E50]">{t.name}</div>
              <div className="text-sm font-semibold text-[#2C3E50]/70">{t.role}</div>
            </div>
            <div className="flex gap-2">
              <button onClick={prev} aria-label="Previous" className="w-11 h-11 rounded-full border-2 border-[#2C3E50] bg-white hover:bg-[#F4B93E] flex items-center justify-center">
                <ChevronLeft size={20} />
              </button>
              <button onClick={next} aria-label="Next" className="w-11 h-11 rounded-full border-2 border-[#2C3E50] bg-[#2C3E50] text-white hover:bg-[#E64B2B] hover:border-[#E64B2B] flex items-center justify-center">
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-center gap-2">
          {testimonials.map((tItem, i) => (
            <button key={tItem.name} onClick={() => setIdx(i)} aria-label={`Slide ${i+1}`} className={`h-2 rounded-full transition-all ${i === idx ? 'w-8 bg-[#2C3E50]' : 'w-2 bg-[#2C3E50]/30'}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
